import mutations from './mutations';
import queries from './queries';

export { queries, mutations };
